import { useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { WD } from '../../../warningDashboard/warningTheme';
import { ENTRIES_URL, FIGURE, LEVEL_TONE } from '../utils/constants';
import { formatShort } from '../utils/dates';
import { fmtHours, round1 } from '../utils/hours';
import useSave from '../utils/useSave';
import ConfirmDialog from './ConfirmDialog';
import EntryForm from './EntryForm';

/** One block of logged time - day, from–to, hours, note - with edit (in place) and delete (after a confirm). */
export default function EntryRow({ entry, plan, today, onChanged }) {
  const [editing, setEditing] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [busy, run] = useSave(onChanged);

  if (editing) {
    return (
      <Box sx={{ p: 1, borderRadius: 2, bgcolor: WD.card, border: `1px solid ${WD.border}` }}>
        <EntryForm plan={plan} today={today} entry={entry} onChanged={onChanged} onDone={() => setEditing(false)} />
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={1} sx={{ px: 1.25, py: 0.5, borderRadius: 2, bgcolor: WD.card, border: `1px solid ${WD.border}`, fontSize: 12.5 }}>
      <Typography component="span" sx={{ flexShrink: 0, fontSize: 12.5, fontWeight: 600, ...FIGURE }}>{formatShort(entry.workDate)}</Typography>
      <Typography component="span" sx={{ flexShrink: 0, fontSize: 12.5, color: WD.inkMuted, ...FIGURE }}>{entry.fromTime}–{entry.toTime}</Typography>
      <Typography component="span" sx={{ flexShrink: 0, fontSize: 12.5, fontWeight: 700, ...FIGURE }}>{fmtHours(round1(entry.minutes / 60))}</Typography>
      <Typography component="span" noWrap title={entry.note || ''} sx={{ flex: 1, minWidth: 0, fontSize: 12.5, color: WD.inkFaint }}>{entry.note || ''}</Typography>
      <IconButton size="small" aria-label="Edit entry" onClick={() => setEditing(true)}>
        <EditRoundedIcon sx={{ fontSize: 16 }} />
      </IconButton>
      <IconButton size="small" aria-label="Delete entry" onClick={() => setConfirming(true)} disabled={busy} sx={{ color: LEVEL_TONE.overloaded.text }}>
        <DeleteOutlineRoundedIcon sx={{ fontSize: 16 }} />
      </IconButton>
      <ConfirmDialog
        open={confirming}
        setOpen={setConfirming}
        title="Delete time entry"
        note={`Delete ${entry.fromTime}–${entry.toTime} on ${formatShort(entry.workDate)}?`}
        loading={busy}
        onConfirm={() => run({ method: 'delete', url: `${ENTRIES_URL}/${entry.entryId}` })}
      />
    </Box>
  );
}
